module.exports = __webpack_public_path__ + "resources/img/img-zenius-apm-02.f83277645e9db64039dad117924f5bd9.png";